module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Prologue")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2sub"
  }, [_vm._v("October 2002")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("M")]), _vm._v("aybe someday I’ll have kids of my own. I hope so. If I do, they’ll probably ask what part I played in the movement that changed the world. And because I’m not the person I once was, I’ll tell them the truth. My part was nothing. I did nothing. I was just the guy in the corner taking notes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My name is Chris Chandler, and I’m an investigative reporter. Or at least I was. Until I found out that actions have consequences and not everything is under my control. Until I found out that I couldn’t change the world at all, but a seemingly ordinary twelve-year-old boy could change the world completely—for the better, and forever—working with nothing but his own altruism, one good idea, and a couple of years. And a big sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And a splash of publicity. That’s where I came in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can tell you how it all started.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("It started with a teacher who moved to Atascadero, California, to teach social studies to junior high school students. A teacher nobody knew very well, because they couldn’t get past his face. Because it was hard to look at his face.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It started with a boy who didn’t seem all that remarkable on the outside but who could see past his teacher’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It started with an assignment that this teacher had given out a hundred times before, with no startling results. But that assignment in the hands of that boy caused a seed to be planted, and after that, nothing in the world would ever be the same. Nor would anybody want it to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And I can tell you what it became. In fact, I’ll tell you a story that will help you understand how big it grew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About a week ago my car stalled in a busy intersection, and it wouldn’t start again no matter how many times I tried. It was rush hour, and I thought I was in a hurry. I thought I had something important to do, and it couldn’t wait. So I was standing in the middle of the intersection looking under the hood, which was a little silly, because I can’t fix cars. What did I think I would see?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("I’d been expecting this. It was an old car. It was as good as gone.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A man came up behind me, a stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s get it off to the side of the road,” he said. “Here. I’ll help you push.” When we got it—and ourselves—to safety, he handed me the keys to his car. A nice silver Acura, barely two years old. “You can have mine,” he said. “We’ll trade.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t give me the car as a loan. He gave it to me as a gift. He took my address, so he could send me the title. And he did send the title; it just arrived today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A great deal of generosity has come into my life lately,")]), _vm._v(" the note said, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("so I felt I could take your old car and use it as a trade-in. I can well afford something new, so why not give as good as I’ve received?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s what kind of world it’s become. No, actually, it’s more. It’s become even more. It’s not just the kind of world in which a total stranger will give me his car as a gift. It’s the kind of world in which the day I received that gift was not dramatically different from all other days. Such generosity has become the way of things. It’s become commonplace.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("So this much I understand well enough to relate: It started as an extra-credit assignment for a social ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("studies class and turned into a world where no one goes hungry, no one is cold, no one is without a job or a ride or a loan.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And yet at first people needed to know more. Somehow it was not enough that a boy barely in his teens was able to change the world. Somehow it had to be known why the world could change at just that moment, why it could not have changed a moment sooner, what Trevor brought to that moment, and why it was the very thing that moment required.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that, unfortunately, is the part I can’t explain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was there. Every step of the way, I was there. But I was a different person then. I was looking in all the wrong places. I thought it was just a story, and the story was all that mattered. I cared about Trevor, and I cared about my work, but I didn’t know what my work could really mean until it was over. I wanted to make lots of money. I did make lots of money. I gave it all away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t know who I was then, but I know who I am now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trevor changed me, too.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("I thought Reuben would have the answers. Reuben St. Clair, the teacher who started it all. He was closer to Trevor than anybody except maybe ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Trevor’s mother, Arlene. And Reuben was looking in all the right places, I think. And I believe he was paying attention.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So, after the fact, when it was my job to write books about the movement, I asked Reuben two important questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was it about Trevor that made him different?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reuben thought carefully and then said, “The thing about Trevor was that he was just like everybody else, except for the part of him that wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t even ask what part that was. I’m learning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I asked, “When you first handed out that now-famous assignment, did you think that one of your students would actually change the world?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And Reuben replied, “No, I thought they all would. But perhaps in smaller ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People gradually stopped needing to know why. We adjust quickly to change, even as we rant and rail and swear we never will. And everybody likes a change if it’s a change for the better. And no one likes to dwell on the past if the past is ugly and everything is finally going well.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The most important thing I can add from my own observations is this: Knowing it started from unremarkable circumstances should be a comfort ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("to us all. Because it proves that you don’t need much to change the entire world for the better. You can start with the most ordinary ingredients. You can start with the world you’ve got.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 63
// module chunks = 0